import SolarIcon from 'components/icons/SolarIcon';

interface DashActionProps {
    label: string;
    onClick: () => void;
}

const DashAction = ({ label, onClick }: DashActionProps) => (
    <button
        type="button"
        className="object-analytics-item__action object-analytics-dash__edit"
        onClick={onClick}
        title={label}
        aria-label={label}
    >
        <SolarIcon name="pencil" aria-hidden="true" />
    </button>
);

export default DashAction;
